
const currency = { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }

function yAxisLabeller() {
  return this.value.toLocaleString('en', currency)
}

function pointFormatter() {
  return 'Monthly expenses in ' + this.x + ' are ' + this.y.toLocaleString('en', currency)
}

const expenseSummaryChartConfig = {
  chart: {
    type: 'area',
    height: 300
  },

  credits: {
    enabled: false
  },

  title: {
    text: false
  },

  xAxis: {
    max: 2040
  },

  yAxis: {
    labels: {
      formatter: yAxisLabeller
    },
    title: {
      text: 'Expense Amount'
    }
  },
  legend: {
    enabled: false
  },

  tooltip: {
    formatter: pointFormatter
  },

  plotOptions: {
    area: {
      lineColor: '#26a69a'
    },
    series: {
      pointStart: 2017
    }
  },

  series: [{
    fillColor: {
      linearGradient: [0, 0, 0, 300],
      stops: [
        [0, '#8DC248'],
        [1, 'rgba(141,194,72,0.15)']
      ]
    },
    name: 'Combined Expenses',
    data: undefined,
    step: true,
  }]
}

export {
  expenseSummaryChartConfig
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Expenses/Summary/chart.ts